import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Login from './Components/login-php-api';
import Login from './Components/Login';
import Layout from './Layout/Layout';
import Landing from './Components/Landing';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logoutDueToInactivity = useCallback(() => {
    setUser(null);
    localStorage.removeItem('user');
    toast.info("Your session has timed out due to inactivity.", {
      autoClose: 50000, 
    });
  }, []);

  useEffect(() => {
    // Check localStorage for user session
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      toast.dismiss(); // Dismiss any existing toast when a user session is found
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!user) return;

    const activityEvents = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    let timeoutId;

    const resetTimeout = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(logoutDueToInactivity, 10 * 60 * 1000); // 5 minutes
    };

    const handleActivity = () => {
      resetTimeout();
    };

    activityEvents.forEach(event => window.addEventListener(event, handleActivity));

    resetTimeout();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      activityEvents.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, [user, logoutDueToInactivity]);

  const handleLogin = (username) => {
    setUser(username);
    localStorage.setItem('user', JSON.stringify(username));
    toast.dismiss();
  };
  

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  if (loading) {
    return <div>Loading...</div>; // Add a loading indicator if needed
  }

  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login setUser={handleLogin} />} />
        {/* <Route
          path="/DataFetch"
          element={user ? <DataFetch user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
        /> */}

           <Route
          path="/landing"
          element={user ? <Landing user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
        />
    <Route
          path="/layout"
          element= {user ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
        {/* <Route
          path="/layout"
          element={user ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
        /> */}
        <Route
          path="/"
          element={<Navigate to={user ? "/landing" : "/login"} />}
        />
        <Route path="*" element={<Navigate to="/login" />} />

      </Routes>
    </Router>
  );
};

export default App;